export default [{
  path: '/tms',
  name: 'tms',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/kpp/tms/index')
}]
